import CardElementPhotoSelectionControl from './CardElementPhotoSelectionControl';

export default CardElementPhotoSelectionControl;
